import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type RegisterUserSsoMutationVariables = Types.Exact<{
  provider: Types.LoginProvider;
  code: Types.Scalars['String']['input'];
}>;


export type RegisterUserSsoMutation = { __typename: 'Mutation', registerUserSso: { __typename: 'RegisterUserSsoResult', token: string, isExistingUser?: boolean | null, onboardingCompleted: boolean, user: { __typename: 'SignupUserInfo', uuid: string, email: string, firstName?: string | null, lastName?: string | null, isActive: boolean, isOnboardingCompleted: boolean, ssoProvider?: string | null, has3dExperience?: boolean | null, newsletterOptIn?: boolean | null, emailNotifications?: boolean | null }, organization: { __typename: 'SignupOrganizationInfo', uuid: string, name?: string | null, type?: Types.OrganizationType | null, stripeSubscriptionStatus?: string | null, trialEndsAt?: string | null }, membership: { __typename: 'SignupMembershipInfo', uuid: string, role: Types.MembershipRole } } };

export const RegisterUserSsoDocument = gql`
    mutation RegisterUserSso($provider: LoginProvider!, $code: String!) {
  registerUserSso(provider: $provider, code: $code) {
    token
    user {
      uuid
      email
      firstName
      lastName
      isActive
      isOnboardingCompleted
      ssoProvider
      has3dExperience
      newsletterOptIn
      emailNotifications
    }
    organization {
      uuid
      name
      type
      stripeSubscriptionStatus
      trialEndsAt
    }
    membership {
      uuid
      role
    }
    isExistingUser
    onboardingCompleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserSsoGQL extends Apollo.Mutation<RegisterUserSsoMutation, RegisterUserSsoMutationVariables> {
    override document = RegisterUserSsoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }